import { TimelineMax } from "gsap";
import { SplashText } from "../modules/SplashText";
import { IDimConfig, LayoutDimData, ResizeHelper } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { SplashView } from "../SplashController"
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkGameConfig } from "../../../../PunkGameConfig";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { TranslationConfig } from "../../../../translations/TranslationConfig";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export class SplashViewFullHouse extends BaseView implements SplashView  {
    
    protected _txt:SplashText;
    protected _img:PIXI.Sprite;

    protected layoutDim_img: IDimConfig = {
        dimOrientation: {
            landscape: {
                scale: new PIXI.Point(0.7, 0.7),
                position: new PIXI.Point(360, 380),
                layout: {
                    left: new PIXI.Point(360, 380),
                    right: new PIXI.Point(360, 380)
                }
            },
            portrait: {
                scale: new PIXI.Point(0.8, 0.8),
                position: new PIXI.Point(360, 400)
            }
        },
        WIDTH: 0,
        HEIGHT: 0,
    };
    
    protected readonly DEFAULT_TXT_STYLE = {
        fontWeight : FontWeight.BOLD,
        fontFamily: "Helvetica",
        align: "center",
        fill: "#ffffff",
        fontSize: 34,
        wordWrap: true,
        wordWrapWidth: 600,
        
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 4,
    };

    protected _timeLine:TimelineMax;

    // protected DEFAULT_TXT_STYLE:TextStyleOptions;

    constructor(textStyle:TextStyleOptions){
        super();
        // this.DEFAULT_TXT_STYLE = textStyle;
    }

    protected initAnimations():void{
        
        this._txt = new SplashText(Translation.translate(TranslationConfig.FULL_HOUSE) ,this.DEFAULT_TXT_STYLE);
        this._img = new PIXI.Sprite(GameResources.getTextures("Train_Screens/6x6")[0]);
        this._img.anchor.set(0.5,0.5);

        const dimData:LayoutDimData = ResizeHelper.calcDim(this.layoutDim_img);
        this._img.scale = dimData.scale;
        this._img.position = dimData.position;

        this.addChild(this._img);
        this.addChild(this._txt);
        this._txt.position = new PIXI.Point(360,160);
        this._txt.anchor.set(0.5,0);
        // console.warn(this._txt.height);
        // if(this._txt.height > )
        this.visible = false;


        StageManager.getLayer(PunkGameConfig.instance.LAYERS.POSTER.name).addChild(this);
    }

    public play():TimelineMax{
        this._timeLine = new TimelineMax();
        this.visible = true;
        return new TimelineMax();
    }

    public stop():TimelineMax{
        this._timeLine = new TimelineMax();
        this.visible = false;
        return this._timeLine;
    }

    protected onResize():void{
        const dimData:LayoutDimData = ResizeHelper.calcDim(this.layoutDim_img);
        this._img.scale = dimData.scale;
        this._img.position = dimData.position;
    }
}
